import React, { h, JSX } from 'preact'
import { WidgetConfigProvider, TenantProvider } from 'grosella/context'
import { WidgetConfig } from './types'
import { SearchWidget } from './components/widgets'

export const App: React.FunctionalComponent<WidgetConfig> = (appSettings) => {
    return (
        <WidgetConfigProvider config={appSettings}>
            <TenantProvider>
                <SearchWidget />
            </TenantProvider>
        </WidgetConfigProvider>
    )
}
